import React from 'react';
import Hero from '../components/common_components/Hero';
import { NodejsFeature, NodeJsItem, ReactFeatures, ReactWordpressNodejs, WordpressBackground } from '../components/pageComponents/services/ReactWordpressNodejs';
import Halment from '../faetures/Halment';
import badge from "../images/badge-final-2.svg";
import heroImage from "../images/featured/react_logo.webp";
import Layout from '../layout/Layout';
function Services() {
  return (
    <Layout>
       <Halment title="Services" />
       <Hero
            main="Full stack web development with React, Node and Wordpress."
            badge={badge}
            heroImage={heroImage}
            link="/pricing"
            smallText="I help you stay alive and ahead"
            outlineButton="See all Pricing"
            description="I create beautiful, intiutive applications with the scalability, adaptability and convenience of React JS and backend for Node.js and others css libraries and packeges. Besides I also provide CMS developmwnt service Wordpress design and development with premium themes and plugins."
       />
       <div className="margin_container">
        <ReactWordpressNodejs/>
       </div>
       <WordpressBackground/>
       <ReactFeatures/>
       <NodejsFeature/>
       <NodeJsItem/>
    </Layout>
  )
}



export default Services ;






